import React from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row, Card } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../Hooks";

import AsyncSvg from "../../AsyncSvg";
import valueIcon from "../../../assets/images/values.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/info-icon.svg";

import "./style.scss";

const ThemesPillars = ({
  strategy,
  selectedThemePillar,
  setSelectedThemePillar,
}) => {
  const [isAr] = useIsAr();
  const data =
    +strategy?.StrategyType === 1 ? strategy?.Themes : strategy?.Pillars;

  return (
    <Space
      direction="vertical"
      size="large"
      justify="center"
      className="themes-pillars-container"
    >
      <Row justify="center">
        <Space align="center" size="large">
          <div className="title">
            <FormattedMessage
              id={
                +strategy?.StrategyType === 1
                  ? "common.themes"
                  : "common.pillars"
              }
            />
          </div>

          <Space size="large" align="center">
            {data?.map((item) => (
              <div
                key={item.ID}
                className="item-card-wrapper"
                onClick={() => {
                  if (selectedThemePillar?.ID === item.ID)
                    setSelectedThemePillar(null);
                  else setSelectedThemePillar(item);
                }}
              >
                <Card
                  style={{
                    width: 64,
                    height: 64,
                    backgroundColor:
                      selectedThemePillar?.ID === item.ID
                        ? "white"
                        : item.Color,
                    position: "absolute",
                  }}
                />

                <Card
                  className="item-card"
                  style={{
                    backgroundColor:
                      selectedThemePillar?.ID === item.ID
                        ? item.Color
                        : "white",
                    color:
                      selectedThemePillar?.ID === item.ID ? "white" : "inherit",
                  }}
                >
                  <AsyncSvg
                    defaultSvg={valueIcon}
                    attachment={item.Attachment}
                    color={
                      selectedThemePillar?.ID === item.ID ? "white" : item.Color
                    }
                    style={{ width: 24, height: 24 }}
                  />

                  <div>{isAr ? item?.ArabicName : item?.EnglishName}</div>
                </Card>
              </div>
            ))}
          </Space>
        </Space>
      </Row>

      {selectedThemePillar && (
        <Card className="themes-pillars-container__description">
          <Space align="center">
            <InfoIcon fill="#444444" width={20} height={20} />
            <FormattedMessage
              id={
                +strategy?.StrategyType === 1
                  ? "theme.description"
                  : "pillar.description"
              }
            />
          </Space>
          <div className="text">
            {isAr
              ? selectedThemePillar?.ArabicDescription
              : selectedThemePillar?.EnglishDescription}
          </div>
        </Card>
      )}
    </Space>
  );
};

export default ThemesPillars;
